import { ReactNode } from 'react'

const strings = {
  title: 'Ном ба ном. 34 кушташудаи ҳодисаҳои Хоруғ ва Рӯшон',
  menu: {
    about: 'Подробнее',
    share: 'Поделиться',
    introduction: 'Маълумоти кӯтоҳ',
  },
  footer: {
    followUs: 'Моро ҳамроҳӣ кунед',
    copyright: '© 2022 Радиои Озодӣ | Ҳамаи ҳуқуқ маҳфуз аст',
    contentTitle: 'Дар бораи мо',
    content: `Радиои Озодӣ ахбореро нашр ва масъалаҳоеро инъикос мекунад, ки дар расонаҳои давлатии Тоҷикистон намебинед ва ё расонаҳои дигар аз инъикоси онҳо худдорӣ меварзанд. Радиои Озодӣ бахше аз Радиои Аврупои Озод/Радиои Озодӣ аст, ки бо сармоягузории Конгресс ва тавассути Оҷонси Суханпарокании Байнулмилалии Амрико (USAGM) кор мекунад, вале мақомоти Иёлоти Муттаҳида, аз ҷумла USAGM, ҳақ надоранд, ба мазмуни гузоришҳои он дахолат кунанд.`,
    creatorsTitle: 'Дар тарҳ саҳм гирифтанд:',
    creators: (
      <p>
        <strong>Муаллиф:</strong> Радиои Озодӣ
        <br />
        <strong>Тарҳрезӣ ва ороиш:</strong> Гуруҳи Pangea Digital Dataviz – Олга
        Баришникова, Ян Ҳоффман, Якуб Сиротек ва Денис Артамонов
      </p>
    ),
  },
  home: {
    title: (
      <>
        <span>Ном ба ном.</span> 34 кушташудаи ҳодисаҳои Хоруғ ва Рӯшон
      </>
    ),
    khorog: 'Хоруғ',
    khorug: 'Хоруғ',
    rushon: 'Рӯшон',
    rushan: 'Рӯшон',
    map: {
      popupTemplate: (date: string, people: number, city: string) =>
        `On ${date} at least ${people} people were known to have been killed in the crackdown in ${city}`,
      popups: [
        'Санаи кушта шудани 17 нафар дар Рӯшон барои мо дақиқ нест. Наздиконашон гуфтанд, эҳтимол онҳо дар рӯзи амалиёт, 18-уми майи 2022, кушта шудаанд, аммо ҷасадашонро дертар ёфтанд.',
        'Рӯзи 31-уми майи 2022 дар ноҳияи Рӯшон 5 кас кушта шудаанд.',
        'Наздикони 4 нафар дар Рӯшон дақиқ гуфтанд, ки онҳо рӯзи 18-уми май кушта шуданд. Сокинон бовар доранд, дар ин рӯз мардуми зиёд ҷон бохта, вале ҷасадҳоро дертар гирифтанд.',
        'Ба иттилои хешовандон, рӯзи 19-уми май дар Рӯшон дастикам се нафар кушта шудаанд.',
        'Дар ҷараёни даргириҳо дар Хоруғ як нафари дигар кушта шуда, вале санаи маргаш барои мо дақиқ нест.',
        'Рӯзи 12-уми июни 2022 дар шаҳри Хоруғ ду нафар кушта шуданд. ',
        'Рӯзи 22-юми май дар Хоруғ, маркази ВМКБ, як нафар кушта шуд.',
        'Рӯзи 16-уми май, дар оғози тазоҳуроти ҷавонони норозӣ ва посухи мақомоти интизомӣ дар Хоруғ, як нафар кушта шуд.',
      ],
      mayShort: 'май',
      juneShort: 'июн',
      unknownDate: 'Номаълум',
    },
    postedOn: '',
    updated: 'Обновлено:',
    seeTheirStories: 'Рӯйхат ва маълумот инҷост...',
    listTitle: 'Рӯйхати пурра',
    noResults: 'Ничего не найдено',
    filterByAge: 'Син',
    filterByPlaceOfBirth: 'Ҷойи зист',
    allVictims: 'Рӯйхати пурра',
    chartCaption: `Соли таваллуди кушташудаҳо. Маълумот аз наздикон ва шахсони огоҳ гирдоварӣ шуд.`,
  },
  detail: {
    backButton: 'БА ҚАФО',
    previousButton: 'ПЕШӢ',
    nextButton: 'БАЪДӢ',
    years: (v: ReactNode) => `${v}-сола`,
    seeAdditionalInfo: 'Маълумоти иловагӣ',
  },
}
export default strings
